import React from 'react';
import './featureContent.css';

/**
 * Renders an app screenshot styled as a designed graphic rather than a raw
 * screenshot: cropped status bar, rounded corners, soft shadow, colored glow
 * and optional tilt. No phone/device frame.
 *
 * @param {string} src - image path (e.g. from process.env.PUBLIC_URL)
 * @param {string} alt - accessible description
 * @param {'left'|'right'|'none'} tilt - rotation direction, defaults to 'right'
 * @param {'sm'|'md'|'lg'} size - max-width preset
 */
function FeatureScreenshot({ src, alt, tilt = 'none', size = 'md', className = '', onClick, badge, caption }) {
    const tiltClass = tilt === 'none' ? '' : ` fc-screenshot-tilt-${tilt}`;
    const clickClass = onClick ? ' fc-screenshot-clickable' : '';
    return (
        <div
            className={`fc-screenshot fc-screenshot-${size}${tiltClass}${clickClass} ${className}`.trim()}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
        >
            <div className="fc-screenshot-glow" aria-hidden="true" />
            <div className="fc-screenshot-frame">
                {badge && <span className="fc-screenshot-badge">{badge}</span>}
                <img src={src} alt={alt} className="fc-screenshot-img" loading="lazy" decoding="async" />
            </div>
            {caption && <p className="fc-screenshot-caption">{caption}</p>}
        </div>
    );
}

export default FeatureScreenshot;
